import ScaleBar from './ScaleBar';

export default ScaleBar;